import { Injectable, inject } from '@angular/core';
import {
  BasePageMetaResolver,
  PageHeadingResolver,
  PageMetaResolver,
  PageTitleResolver,
  PageType,
} from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable()
export class CustomContentPageMetaResolver
  extends PageMetaResolver
  implements PageTitleResolver, PageHeadingResolver
{
  protected basePageMetaResolver = inject(BasePageMetaResolver);

  constructor() {
    super();
    this.pageType = PageType.CONTENT_PAGE;
  }

  resolveHeading(): Observable<string | undefined> {
    return this.basePageMetaResolver.resolveTitle();
  }

  resolveTitle(): Observable<string | undefined> {
    return this.basePageMetaResolver.resolveTitle();
  }
}
